import { IGetAllClienteUseCase } from "../../../presentation/useCases/read/get_all_cliente_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IComercialRepository } from "../../repositories/comercial_repositories";
import { Cliente } from "../../models/cliente";
import { ClienteLista } from "../../models/clienteLista";

/**
 * GetAllClienteUseCase
 */

export class GetAllClienteUseCase extends BasePaginatedUseCase<ClienteLista> implements IGetAllClienteUseCase {
  constructor(private readonly repository: IComercialRepository) {
    super();
  }

  async execute(
    idsCentroCusto?: number[],
    nomeFantasia?: string,
    cnpj?: string,
    cpf?: string,
    unidade?: string,
    currentPage?: number,
    rowsPerPage?: number
  ): Promise<void> {

    const response = await this.repository.getAllClienteLista(
      idsCentroCusto,
      nomeFantasia,
      cnpj,
      cpf,
      unidade,
      currentPage,
      rowsPerPage
    );

    this._items = response.items;
    this._pageSize = response.pageSize;
    this._currentPage = response.currentPage;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;

  }
}
